var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarListBand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.333A1.667 1.667 0 1 0 12 2a1.667 1.667 0 0 0 0 3.333zm8.333 5a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333zm-16.666 0a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333zM17.833 22H6.167v-1.936c0-1.009.6-1.922 1.533-2.307.94-.39 2.345-.757 4.3-.757 1.955 0 3.36.367 4.3.757a2.491 2.491 0 0 1 1.533 2.307V22zM8.667 12a3.333 3.333 0 0 1 6.666 0c0 1.84-1.492 4.167-3.333 4.167-1.84 0-3.333-2.326-3.333-4.167z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarListBand);
export default __webpack_public_path__ + "static/media/car-list-band.932eb5094dbdb0809c779c4cd9e88b30.svg";
export { ForwardRef as ReactComponent };